import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'

const http = axios.create({
  baseURL: process.env.VUE_APP_TMP_TAPIR_API_URL_BASE,
})

const rawHttp = axios.create()

async function requestInterceptor(config) {
  const token = await firebase.auth().currentUser.getIdToken()

  if (!token) {
    return config
  }

  config.headers.Authorization = `Bearer ${token}`

  return config
}

function responseInterceptor(response) {
  return response
}

http.interceptors.request.use(requestInterceptor)
http.interceptors.response.use(responseInterceptor)

export default { http, rawHttp }
